// Module
var code = `<div class="{{'data-source-widget' + (comboBoxButtonType?'':'-toUp')}}" 
    style="{{#.zIndex}}z-index:{{.zIndex}};{{/}};{{>visibility}};"
    aria-disabled="{{!enabled}}">

    {{#if comboBoxButtonType}}
    <div class="button {{opened?'opened':'closed'}}" 
        on-click="onButtonClick" 
        as-tooltip="enabled ? (opened?openedBtnTooltip:closedBtnTooltip) : disabledTooltip"
        aria-disabled="{{!enabled}}">
        <div class="text">{{buttonTitle}}</div>
        <div class="arrow-icon">
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{opened ? 'ArrowUp' : 'ArrowDown'}}"></use>
            </svg>
        </div>
    </div>
    {{elseif !opened}}
    <div class="button closed" 
        as-tooltip="enabled ? closedBtnTooltip : disabledTooltip" 
        on-click="onButtonClick" 
        aria-disabled="{{!enabled}}"> 
        <div class="text">{{buttonTitle}}</div>
        <div class="arrow-icon">
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#dataSourceArrowUp"></use>
            </svg>
        </div>
    </div>
    {{/if}}

    <!-- Область с отображаемыми данными -->
    <div class="data">
        {{#if CustomText}}
        <div class="noData-customText">
            <div class="customText">{{CustomText}}</div>
        </div>
        {{else}}
        <div class="column-first">
            {{#if comboBoxButtonType}}
            <!-- Часы обозначающие delayed data или пустая ячейка колонки -->
            <div>
                <div class="js-data-source-delayed" style="display: {{delayedVisible ? 'block':'none'}};" as-tooltip="delayedTooltip">
                    <svg>
                        <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#delayedData"></use>
                    </svg>
                </div>
            </div>
            {{else}}
            <div on-click="onButtonClick" as-tooltip="openedBtnTooltip">
                <div>
                    {{buttonTitle}}
                </div>
                <div class="arrow-icon">
                    <svg>
                        <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#dataSourceArrowDown"></use>
                    </svg>
                </div>
            </div>
            {{/if}}
            <div>{{priceLabel}}:</div>
            <div>{{sizeLabel}}:</div>
            <div>{{venueLabel}}:</div>
        </div>
        <div class="column">
            <div>{{lastLabel}}</div>
            <div>{{lastPrice}}</div>
            <div>{{lastSize}}</div>
            <div>{{lastVenue}}</div>
        </div>
        <div class="column">
            <div>{{bidLabel}}</div>
            <div>{{bidPrice}}</div>
            <div>{{bidSize}}</div>
            <div>{{bidVenue}}</div>
        </div>
        <div class="column">
            <div>{{askLabel}}</div>
            <div>{{askPrice}}</div>
            <div>{{askSize}}</div>
            <div>{{askVenue}}</div>
        </div>
        {{/if}}
    </div>
</div>`;
// Exports
export default code;